<template src="./IdiResearchProfessor.html"></template>

<script>
import AnnouncementOpen from "../../components/AnnouncementOpen/AnnouncementOpen";
import NewsVerticalCard from "../../components/NewsVerticalCard/NewsVerticalCard";
import AnnouncementCloseHorizontal from "../../components/AnnouncementCloseHorizontal/AnnouncementCloseHorizontal";
import HorizontalCardComingSoon from "../../components/HorizontalCardComingSoon/HorizontalCardComingSoon";
import VerticalCardComingSoon from "../../components/VerticalCardComingSoon/VerticalCardComingSoon";
import ArrobaMedellinArrobitaNoData from "@/components/ArrobaMedellinArrobitaNoData/ArrobaMedellinArrobitaNoData";
import ArrobaMedellinNoData from "../../components/ArrobaMedellinNoData/ArrobaMedellinNoData";
import idiService from "../../services/Idi";
import ChooseUniversity from "../../components/ChooseUniversity/ChooseUniversity";
import announcementService from "../../services/Announcement";
import { mapGetters } from "vuex";
import newsService from "../../services/News";

export default {
  name: "idiResearchProfessor",
  components: {
    ArrobaMedellinArrobitaNoData,
    ArrobaMedellinNoData,
    AnnouncementOpen,
    NewsVerticalCard,
    AnnouncementCloseHorizontal,
    HorizontalCardComingSoon,
    VerticalCardComingSoon,
    ChooseUniversity,
  },
  data() {
    return {
      openCalls: [],
      closedCalls: [],
      allNews: [],
      myCalls: [],
      myResearchGroups: [],
      allResearchGroups: { items: [] },
      role: "",
      institutionId: "",
    };
  },
  created() {
    this.institutionId = this.$store.state.User.user.institutionId.id;
  },
  mounted() {
    this.getAllInfo();
    this.role = this.$store.state.User.user.role.name;
  },
  methods: {
    async getAllInfo() {
      try {
        const objOpenCalls = {
          state: true,
          institution: this.institutionId,
          publicState: "both",
        };
        const objClosedCalls = {
          state: false,
          institution: this.institutionId,
          publicState: "both",
        };
        const objNews = {
          id: this.institutionId,
          newsType: "institution",
          institutionId: this.institutionId,
        };
        this.myCalls = await announcementService.myAnnouncementByState(1);
        this.openCalls =
          await announcementService.announcementByStateAndInstitution(
            objOpenCalls
          );
        this.closedCalls =
          await announcementService.announcementByStateAndInstitution(
            objClosedCalls
          );
        this.allNews = await newsService.newsByElement(objNews);
        this.myResearchGroups = await idiService.myGroups();
        this.allResearchGroups = await idiService.listGroups();
      } catch (error) {
        console.error(error);
      }
    },
  },
  computed: {
    calculateCommingSoon() {
      return (quantity, max) => {
        const dif = max - quantity;
        return dif < 0 ? [] : Array(dif);
      };
    },
    roleValidation() {
      return ["TeacherInvestigator"].some((a) => a === this.role);
    },
    ...mapGetters({
      institution: "getInstitutionSelected",
    }),
  },
  watch: {
    institution: async function (value) {
      this.institutionId = value;
      await this.getAllInfo();
    },
  },
};
</script>

<style lang="scss" scoped src="./IdiResearchProfessor.scss"></style>